module.exports = __webpack_public_path__ + "static/media/bombay_stock_exchange_logo.daa1c669.svg";